<template>
  <!-- Intentionally blank. This route exists only so Pentakill's iframe
       navbar can resolve the `location-settings-basic` named route and
       postMessage the path to OWA, which renders the Settings page natively
       (migrated out of Pentakill, see OVA-681). This component is never
       visibly shown — OWA swaps to the native page on navigation. -->
  <div />
</template>

<script>
export default {
  name: 'LocationSettingsBasic'
}
</script>

<style scoped lang="scss"></style>
